module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLight.5118e5e0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLight.woff
// module id = 317
// module chunks = 3